import React from "react";
import { Badge } from "@/components/ui/badge";
import {
  LookupService,
  IdentifiedService,
} from "../steps/step-2-service-mapping";

interface SuggestionChipsProps {
  service: LookupService | IdentifiedService;
}

interface ChipState {
  active: boolean;
  label: string;
  description: string;
}

export function SuggestionChips({ service }: SuggestionChipsProps) {
  // Type guard to check if service is IdentifiedService
  const isIdentifiedService = (
    service: LookupService | IdentifiedService
  ): service is IdentifiedService => {
    return (
      "caen" in service &&
      "lista_oficiala" in service &&
      "smart_search" in service
    );
  };

  // Helper function to determine chip states
  const getChipStates = (): ChipState[] => {
    if (!isIdentifiedService(service)) {
      return [];
    }

    const chips: ChipState[] = [];

    if (service.caen) {
      chips.push({
        active: true,
        label: "Coduri CAEN",
        description: "Găsit prin maparea codurilor CAEN",
      });
    }

    if (service.lista_oficiala) {
      chips.push({
        active: true,
        label: "Lista oficială",
        description:
          (service.lista_details as any)?.descriere ||
          "Găsit în liste oficiale",
      });
    }

    if (service.smart_search) {
      chips.push({
        active: true,
        label: "Smart search",
        description: service.scor_incredere
          ? `Găsit online (${Math.round(service.scor_incredere * 100)}% siguranță)`
          : "Găsit prin căutare online",
      });
    }

    return chips;
  };

  const chips = getChipStates();

  return (
    <div className="flex flex-wrap gap-1">
      {chips.map((chip, index) => (
        <Badge
          key={index}
          variant="outline"
          className="text-xs px-1.5 py-0.5 border-green-500 text-green-700 bg-green-50"
          title={chip.description}
        >
          {chip.label}
        </Badge>
      ))}
    </div>
  );
}
